import { render, staticRenderFns } from "./MyCoursesCourseBox.vue?vue&type=template&id=059909c4&scoped=true"
import script from "./MyCoursesCourseBox.vue?vue&type=script&lang=js"
export * from "./MyCoursesCourseBox.vue?vue&type=script&lang=js"
import style0 from "./MyCoursesCourseBox.vue?vue&type=style&index=0&id=059909c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059909c4",
  null
  
)

export default component.exports